export default __webpack_public_path__ + "static/media/message-icon.f6b7942f.svg";